export default {
  "login": {
    "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["e-Mail2"])}
  },
  "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
}